import { render, staticRenderFns } from "./select-one-menu.vue?vue&type=template&id=5512cc9b"
import script from "./select-one-menu.vue?vue&type=script&lang=js"
export * from "./select-one-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports